module.exports = __webpack_public_path__ + "img/type-sample-active.0100a134.svg";